import { render } from "./TheRestoreSessionPage.vue?vue&type=template&id=896981c6&scoped=true"
import script from "./TheRestoreSessionPage.vue?vue&type=script&lang=js"
export * from "./TheRestoreSessionPage.vue?vue&type=script&lang=js"

import "./TheRestoreSessionPage.vue?vue&type=style&index=0&id=896981c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896981c6"]])

export default __exports__